export enum CreatedFrom {
  CLUB = 'CLUB',
  ONLINE_EVENT = 'ONLINE_EVENT',
  SPARKLE = 'SPARKLE',
  WEBINAR = 'WEBINAR',
  ON_FIRE = 'ON_FIRE'
}

export enum Visibility {
  PUBLIC = 'PUBLIC',
  CLUB = 'CLUB',
  HOTMART = 'HOTMART',
  DEFAULT = 'DEFAULT',
  PRIVATE = 'PRIVATE'
}

export enum PlaybackStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DOWNLOAD_AVAILABLE = 'DOWNLOAD_AVAILABLE',
  DISCONNECTED = 'DISCONNECTED'
}

export enum Provider {
  HOTMART = 'HOTMART',
  VIMEO = 'VIMEO',
  YOUTUBE = 'YOUTUBE',
  YOUTUBE_HOTMART = 'YOUTUBE_HOTMART',
  MUX_STUDIO_HOTMART = 'MUX_STUDIO_HOTMART'
}

export enum Status {
  CREATING = 'CREATING',
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  CLOSING = 'CLOSING',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
  FAILED = 'FAILED'
}

export interface LiveStatus {
  status: Status,
  playbackStatus: PlaybackStatus
}

export interface Transmission {
  amountLead: number,
  code: string,
  completedAt?: string,
  createdFrom: CreatedFrom,
  description: string,
  enableVodPlayback?: boolean,
  inputKey: string,
  inputUrl: string,
  conversationId: string,
  largeThumbnailLink: string,
  liveStartAt: string,
  mediaCode: string,
  name: string,
  playbackStatus: PlaybackStatus,
  projectId?: string,
  provider: Provider,
  smallThumbnailLink: string,
  status: Status,
  url: string,
  visibility: Visibility,
  zoneId: string,
  embedHtml: string,
  playerJwt: string,
  applicationCode: string,
  userCode: string
}

export interface Feedback {
  feedback: string,
  id: number,
  leadCode: string,
  ratingStar: number,
  scheduleCode: string
}

export interface NextTransmissionInfo {
  code: string,
  id: number,
  largeThumbnailLink: string,
  liveStartAt: string,
  mediaCode: string,
  name: string,
  smallThumbnailLink: string
}

export interface TransmissionInfo {
  code: string,
  name: string,
  conversationId: string,
  description: string,
  visibility: Visibility,
  provider: Provider,
  completed: boolean,
  liveStartAt: string,
  zoneId: string,
  largeThumbnailLink: string,
  smallThumbnailLink: string,
  enableVodPlayback: boolean,
  maxDurationMinutes: number,
  maxParticipants: number,
  createdFrom: CreatedFrom,
  status: Status,
  playbackStatus: PlaybackStatus,
  embedUrl: string,
  playerJwt: string,
  applicationCode: string,
  userCode: string
}

export enum OnFireLanguage {
  PORTUGUES = 'PORTUGUES',
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH',
  LIBRAS = 'LIBRAS'
}

export interface OnFireLanguageResponse {
  id: number,
  scheduleCode: string,
  language: OnFireLanguage,
  module: string
}

export enum MobileTab {
  COUNTER = 'counter',
  CHAT = 'chat',
  INFORMATION = 'information',
  SCHEDULE = 'schedule',
  LANGUAGE = 'language'
}

export interface GetSourceParams {
  mediaId: string,
  provider: Provider,
  embedUrl?: string | null,
  contactId?: string | null,
  leadCode?: string,
  playerJwt?: string | null,
  applicationCode?: string | null,
  userCode?: string | null
}

export interface GetSourceByProviderParams {
  mediaId: string,
  embedUrl?: string | null,
  leadCode?: string | null,
  playerJwt?: string | null,
  applicationCode?: string | null,
  userCode?: string | null
}

